export default function getBrowserTimeZone(): string {
  try {
    const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
    return timeZone;
  } catch (error) {
    console.error(error);
    return '';
  }
}
